import { LoginCard } from '@/features/auth/components/login-card';

export function LoginPage() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-gradient-to-b from-secondary/60 to-background px-4 py-10">
      <LoginCard />
    </div>
  );
}
